import * as p from '@clack/prompts'
import path from 'node:path'
import type { LoadedAuthoredGeneratedSchema } from '@cli-types/core-engine/add-field.js'
import { stringifyProjectJson } from '@cli-utils/shared.js'

export function printPreview(loaded: LoadedAuthoredGeneratedSchema, cwd: string): void {
  p.note(
    `schema: ${loaded.name} (${loaded.kind})\npath: ${path.relative(cwd, loaded.filePath)}\nowner: user\n\n${stringifyProjectJson(loaded.schema).trim()}`,
    'Create schema preview'
  )
}
